module.exports = __webpack_public_path__ + "img/ablelist.0acc2d87.webp";